// extracted by mini-css-extract-plugin
export default {"cls1":"TagSelector-cls1_zMj","cls2":"TagSelector-cls2_Vr9 TagSelector-cls1_zMj"};